'use client';

import { useEffect, useRef, useState, type ReactNode } from 'react';

// Adds `motion-paused` when it scrolls off screen so animations don't keep running.
export function InViewMotion({
  children,
  className,
  rootMargin = '200px',
}: {
  children: ReactNode;
  className?: string;
  rootMargin?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  // Default to running so first paint (and no-JS / SSR) shows live motion;
  // the observer pauses it on the next tick if it starts off-screen.
  const [inView, setInView] = useState(true);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry) setInView(entry.isIntersecting);
      },
      { rootMargin },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div
      ref={ref}
      className={`${inView ? '' : 'motion-paused'}${className ? ` ${className}` : ''}`}
    >
      {children}
    </div>
  );
}
